import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/core/api.service';
import { catchError, mapTo } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorStateService } from '../../shared/services/core/error.service';
import { ExternalConnect } from '../models/externalConnect.model';
import { LoggingService } from '../../shared/services/core/logging.service';

@Injectable({
  providedIn: 'root'
})
export class ExternalProviderService {
  constructor(
    private api: ApiService,
    private errorService: ErrorStateService,
    private loggingService: LoggingService
  ) {}

  async externalRedirectToProvider(request: ExternalConnect) {
    this.loggingService.debug('Beginning external redirect', request);

    let response = await this.api.post('provider/ExternalConnect', request)
    .pipe(
      catchError((err: HttpErrorResponse) => {
        this.errorService.clearErrors();
        this.loggingService.error(err.error.toString());
        this.errorService.addError(err.error.toString());
        throw err;
      }),
      mapTo(null))
    .toPromise();

    return response;
  }

  async generateVideoToken(providerId: number, meetingNumber: string) {
    this.loggingService.debug('Generating token', meetingNumber);

    let response = await this.api.post('provider/videoconference/token/' + providerId + '/' + meetingNumber, null).pipe(
      catchError((err: HttpErrorResponse) => {
        this.errorService.clearErrors();
        this.loggingService.error(err.error.toString());
        this.errorService.addError(err.error.toString());
        throw err;
      }))
    .toPromise();

    return response;
  }
}
